// extracted by mini-css-extract-plugin
export default {"wrapper":"ApiKeysPage_wrapper__IBU5h","title":"ApiKeysPage_title__CwV5O","button":"ApiKeysPage_button__Er4Bh","textFieldLabel":"ApiKeysPage_textFieldLabel__ZlAY9"};